export default {"src":"/newStatic/_next/static/media/telegram_announcement.6efa43cc.svg","height":19,"width":26};